<template>
  <form
    class="mt-5 md:mt-8"
    @submit.prevent="submit"
  >
    <p
      v-if="globalError.length > 0"
      class="mb-5 text-center text-red-500"
      v-html="globalError"
    />
    <EmailField
      ref="email"
      v-model="signInData.email"
    />
    <PasswordField
      v-model="signInData.password"
      class="mt-8"
      label="Password"
      :force-show-valid-icon="signInData.password.length > 0"
    />
    <div class="flex justify-between items-center text-[#808080] mt-5 md:mt-6 text-sm">
      <Checkbox
        class="checkbox"
        :checked="signInData.remember_me"
        bright-tick
        @input="signInData.remember_me = $event, $emit('change:remember-me', signInData.remember_me)"
      >
        Keep me logged in
      </Checkbox>
      <a
        href="/account/password/remind/"
        class="underline forgot-password"
      >
        Forgot password?
      </a>
    </div>
    <div class="text-center mt-8 sm:mt-12">
      <LoaderButton
        :disabled="isDisableSubmitBtn"
        :is-loading="isLoading"
      >
        Sign In
      </LoaderButton>
    </div>
    <div class="mt-5 text-center sm:mt-10">
      <span class="text-[#808080]">Don't have an account?</span>
      <a
        href="/pricing/"
        class="text-sm text-ma"
        @click.prevent="openSignUpModal('Sign up')"
      >Sign up</a>
    </div>
  </form>
</template>

<script>
import updateDeviceToken from '@/services/update-device-token';
import { eventTracker } from '@/utils/eventTracker';
import analyticsEvents from '@/utils/analyticsEvents';
import EmailField from '../Fields/email.vue';
import PasswordField from '../Fields/password.vue';
import Checkbox from '../Fields/checkbox.vue';
import LoaderButton from '../LoaderButton.vue';

export default {
  components: {
    EmailField,
    PasswordField,
    Checkbox,
    LoaderButton,
  },
  props: {
    clickSource: {
      type: String,
      required: true,
    },
    socialError: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      signInData: {
        email: '',
        password: '',
        remember_me: true,
        device_token: '',
      },
      isDisableSubmitBtn: false,
      isLoading: false,
      globalError: '',
    };
  },
  computed: {
    isValidEmail() {
      const re = /\S+?@\S+?\.\S+?/;
      return re.test(this.signInData.email);
    },
    isValidPassword() {
      return this.signInData.password.length > 0;
    },

    signInRedirect() {
      return this.$store.state.signInRedirect;
    },
  },
  watch: {
    socialError(newVal) {
      this.globalError = newVal;
    },
  },
  methods: {
    async submit() {
      eventTracker(analyticsEvents.clickLogin);
      this.globalError = '';

      // Validation
      if (!this.isValidEmail || !this.isValidPassword) {
        this.globalError = 'Email or password incorrect';
        return;
      }
      this.signInData.device_token = updateDeviceToken.getOrUpdateToken();

      try {
        this.isDisableSubmitBtn = true;
        this.isLoading = true;
        const { data } = await window.axios.post('/api/sign-in', this.signInData);
        this.$emit('trackLoginEvent', data.user_id.toString());
        if (this.signInRedirect) {
          window.location.href = this.signInRedirect;
        } else if (data && data.redirect) {
          window.location.href = data.redirect;
        }
      } catch (err) {
        this.isLoading = false;
        this.isDisableSubmitBtn = false;
        if (typeof err.response?.data.message !== 'undefined') {
          this.globalError = err.response.data.message;
        }

        eventTracker(analyticsEvents.loginFailed, { reason: this.globalError });
      }
    },
    openSignUpModal(buttonName) {
      this.$store.dispatch('setOpenSignInModal', { open: false, clickSource: this.clickSource });
      this.$nextTick(() => {
        this.$store.dispatch('setOpenSignUpModal', { open: true, clickSource: this.clickSource, buttonName });
      });
    },
  },
};
</script>

<style scoped>
.text-\[\#534cda\] {
    color: #534cda;
}
.text-\[\#808080\] {
    color: #808080;
}
.forgot-password:hover {
  @apply text-[#534cda];
}
>>> .checkbox > span {
  @apply mr-2;
}
button:disabled {
    opacity: 0.7;
}
</style>
